import { EVariationTypes } from 'core/common/constants/multivariation'
import { createVariation } from 'core/common/helpers/createVariation'
import { isArray, isObject, isEmpty } from 'core/common/utils/is'
import { descriptionTranslate } from '../ProductVariation/utils'

export const groupByMainVariation = allVariations => {
  const EVariationTypesValids = Object.values(EVariationTypes).map(type => type.toLowerCase())
  return allVariations.reduce((acc, variation) => {
    let mainVariation = variation.customAttributes?.find(attr => {
      const attrTypeTranslated = descriptionTranslate(attr.type)

      return EVariationTypesValids.includes(attrTypeTranslated)
    })?.value

    if (!mainVariation) {
      mainVariation = variation.customAttributes?.[0]?.value
    }

    if (!acc[mainVariation]) {
      acc[mainVariation] = []
    }

    acc[mainVariation].push(variation)

    return acc
  }, {})
}

export const createAllAttributesCombinations = (variationTypes, variationValues) => {
  const allVariations = []

  if (isObject(variationValues)) {
    Object.entries(variationValues).forEach(([firstVariationValue, secondVariationValue]) => {
      if (isObject(secondVariationValue) && !isEmpty(secondVariationValue)) {
        Object.entries(secondVariationValue).forEach(
          ([secondVariationValue, thirdVariationValue]) => {
            if (isArray(thirdVariationValue) && !isEmpty(thirdVariationValue)) {
              thirdVariationValue.forEach(thirdVariation => {
                allVariations.push([
                  {
                    type: variationTypes.first,
                    value: firstVariationValue,
                  },
                  {
                    type: variationTypes.second,
                    value: secondVariationValue,
                  },
                  {
                    type: variationTypes.third,
                    value: thirdVariation,
                  },
                ])
              })
            } else {
              allVariations.push([
                {
                  type: variationTypes.first,
                  value: firstVariationValue,
                },
                {
                  type: variationTypes.second,
                  value: secondVariationValue,
                },
              ])
            }
          }
        )
      } else {
        allVariations.push([
          {
            type: variationTypes.first,
            value: firstVariationValue,
          },
        ])
      }
    })
  }

  return allVariations
}

export const extractCustomAttributeTypes = variations => {
  const firstVariation = variations?.[0]
  const EVariationTypesValids = Object.values(EVariationTypes)

  const attributeTypes = firstVariation?.customAttributes
    ?.map(attribute => attribute.type)
    ?.map(type => descriptionTranslate(type))
    .filter(attrType => EVariationTypesValids.includes(attrType))

  const uniqueAttributeTypes = [...new Set(attributeTypes)]

  return uniqueAttributeTypes || []
}

const addCustomAttributes = ({ variation, variationGroupName, values, customAttributesTypes }) => {
  const variationWithAttributes = { ...variation }

  if (customAttributesTypes?.[0]) {
    variationWithAttributes.customAttributes = [
      {
        type: customAttributesTypes?.[0],
        value: variationGroupName,
      },
    ]
  }

  if (customAttributesTypes?.[1]) {
    variationWithAttributes.customAttributes = [
      ...variationWithAttributes.customAttributes,
      {
        type: customAttributesTypes?.[1],
        value: values?.secondAttribute?.[0]?.title,
      },
    ]
  }

  if (customAttributesTypes?.[2]) {
    variationWithAttributes.customAttributes = [
      ...variationWithAttributes.customAttributes,
      {
        type: customAttributesTypes?.[2],
        value: values?.thirdAttribute?.[0]?.title,
      },
    ]
  }

  return variationWithAttributes
}

export const generateVariation = ({
  values,
  variationGroupName,
  variationGroupList,
  customAttributesTypes,
}) => {
  const firstVariationOfGroup = variationGroupList?.[0] || {}
  const { images = [] } = firstVariationOfGroup

  const newVariation = createVariation({
    images,
    newVariation: true,
  })

  const variationWithAttributes = addCustomAttributes({
    variation: newVariation,
    variationGroupName,
    values,
    customAttributesTypes,
  })

  return variationWithAttributes
}
